import Coordinator from 'components/Shared/Coordinator';
import { TCoordinatorInputProps } from './CoordinatorInput.types';

const CoordinatorInput = ({
  id,
  coordinators,
  readonly,
  coordinatorType = 'eventSite',
  label,
}: TCoordinatorInputProps) => {
  return (
    <Coordinator
      id={id}
      coordinators={coordinators}
      coordinatorType={coordinatorType}
      readonly={readonly}
      label={label}
    />
  );
};

export default CoordinatorInput;
